import * as React from 'react';
import { NumberFormatBase } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const currencyFormatter = (value: any) => {
  if (!Number(value)) return '';
  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value / 100);

  return `${amount}`;
};

const NumberFormatCustom = React.forwardRef<any, CustomProps>(
    function NumberFormatCustom(props, ref) {
      const { onChange, ...other } = props;

      return (
        <NumberFormatBase
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value
              }
            });
          }}
          format={currencyFormatter}
          valueIsNumericString
        />
      );
    },
);

export default NumberFormatCustom;
